import { render, staticRenderFns } from "./RequirementDetails.vue?vue&type=template&id=641d7da3&scoped=true"
import script from "./RequirementDetails.vue?vue&type=script&lang=js"
export * from "./RequirementDetails.vue?vue&type=script&lang=js"
import style0 from "./RequirementDetails.vue?vue&type=style&index=0&id=641d7da3&prod&lang=css"
import style1 from "./RequirementDetails.vue?vue&type=style&index=1&id=641d7da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d7da3",
  null
  
)

export default component.exports